import React, { useEffect, useState } from 'react'
import PageHeader from '../../shared/page-header/PageHeader'
import SKAlerts, { CreateAlert } from '../../shared/common-alerts/SKAlerts'
import axios from 'axios'
import { getStorageValues } from '../../shared/CommonFunctions'
import { getApiBaseUrl } from '../../utils/apiConfig'
import { getModulePermissions } from '../../utils/permissionHelper'
import { exportToExcel, exportToPDF } from '../../utils/downloadExportedFiles'
import RTOModal from './RTOModal'
import RTOGrid from './RTOGrid'
import { logAuditEvent } from '../../utils/auditLogger'
import { useLocation, useNavigate } from 'react-router-dom'

function RTOMain(props) {
  const [rtoList, setRtoList] = useState([])
  const [modalIsOpen, setIsOpen] = useState(false)
  const [alert, setAlert] = useState(null)
  const [userPermissions, setUserPermissions] = useState([])
  const [selectedRow, setSelectedRow] = useState(null)
  const [userAction, setUserAction] = useState('View')
  const [defaultExpandedRowId, setDefaultExpandedRowId] = useState(null)
  const moduleName = props.Module || 'RTO Register'
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const modulePermissions = getModulePermissions(props.Module)
    setUserPermissions(modulePermissions || [])
    fetchRTORegisters()
  }, [props.Module])

  useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', `Accessed ${moduleName}`)
  }, [moduleName])

  useEffect(() => {
    const defaultId = location?.state?.DefaultRTORegisterId
    if (defaultId) {
      setDefaultExpandedRowId(defaultId)
      navigate(location.pathname, { replace: true, state: {} })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.state?.DefaultRTORegisterId])

  const fetchRTORegisters = async () => {
    try {
      const params = { UserId: getStorageValues('userId') }
      const response = await axios.get(getApiBaseUrl() + '/rtoregister/getall', { params })
      if (response.status === 200) {
        const payload = response.data?.data
        const list = Array.isArray(payload) ? payload : Array.isArray(payload?.[0]) ? payload[0] : []
        setRtoList(list)
      }
    } catch (error) {
      console.log(error)
      CreateAlert('Unable to load RTO registers', 'Error', setAlert)
    }
  }

  const openModal = async (row, action) => {
    setUserAction(action)
    try {
      const response = await axios.get(getApiBaseUrl() + '/rtoregister/getbyid', {
        params: { RTORegisterId: row?.RTORegisterId }
      })
      const payload = response?.data?.data
      const header = payload?.header || row
      const details = payload?.details || []
      setSelectedRow({ ...header, Details: details })
      setIsOpen(true)
    } catch (error) {
      console.log(error)
      CreateAlert('Unable to load RTO details', 'Error', setAlert)
    }
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  const handleExportExcel = () => {
    const columns = [
      { name: 'Sales #', selector: 'SalesNumber' },
      { name: 'Customer Name', selector: 'CustomerName' },
      { name: 'Payment Mode', selector: 'PaymentMode' },
      { name: 'Mobile Number', selector: 'MobileNumber' },
      { name: 'Status', selector: 'Status' }
    ]
    exportToExcel('RTORegister', columns, rtoList)
  }

  const handleExportPDF = () => {
    const columns = [
      { name: 'Sales #', selector: 'SalesNumber' },
      { name: 'Customer Name', selector: 'CustomerName' },
      { name: 'Payment Mode', selector: 'PaymentMode' },
      { name: 'Mobile Number', selector: 'MobileNumber' },
      { name: 'Status', selector: 'Status' }
    ]
    exportToPDF('RTORegister', columns, rtoList)
  }

  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader
        displayModule={props.Module}
        onRefresh={fetchRTORegisters}
        showPDF={true}
        showExcel={true}
        showPrint={false}
        showRefresh={true}
        onExcelExport={handleExportExcel}
        onPdfExport={handleExportPDF}
        showAddButton={userPermissions.AddModule === 1 ? true : false}
      />
      <RTOGrid
        rtoList={rtoList}
        DefaultExpandedRowId={defaultExpandedRowId}
        onView={(row) => {
          logAuditEvent(moduleName, 'View Button Click', JSON.stringify({ RTORegisterId: row?.RTORegisterId }))
          openModal(row, 'View')
        }}
        onEmail={(row) => {
          logAuditEvent(moduleName, 'Email Button Click', JSON.stringify({ RTORegisterId: row?.RTORegisterId }))
          openModal(row, 'Email')
        }}
        fetchRTORegisters={fetchRTORegisters}
        UserPermissions={userPermissions}
        moduleName={moduleName}
      />
      <RTOModal
        show={modalIsOpen}
        UserAction={userAction}
        onClose={closeModal}
        selectedRow={selectedRow}
        moduleName={moduleName}
      />
    </>
  )
}

export default RTOMain